import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import FitbitIcon from '@mui/icons-material/Fitbit';
import GamepadIcon from '@mui/icons-material/Gamepad';
import CopyrightIcon from '@mui/icons-material/Copyright';

function TSessionIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state        
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageEdit, setErrorMessageEdit] = useState("");

    // FOR Create new Session
    const [Name, setName] = useState('');
    const [Rate, setRate] = useState('');
    const [TaxRate, setTaxRate] = useState('');
    const [HSNcode, setHSNcode] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();

            return;
        }
        // Token is not expired, fetch data
        fetchTreatmentCategory();
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    //search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [isFocused, setIsFocused] = useState(false);
    const fetchtableData = async () => {
        setLoading(true);
        fetchData('TreatmentSessionApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
                console.log(response);
            })
            .catch((error) => {
                console.error('Error fetching Treatment Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('TreatmentSessionApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('TreatmentSessionApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const addGroupRecord = async (e) => {
        e.preventDefault();
        setIsLoading(true); // show loader

        if (!Name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }

        if (!selectedTreatment) {
            setErrorMessage('Treatment is required !');
            setIsLoading(false);
            return;
        }

        // ✅ Check duplicate by comparing case-insensitive
        const isDuplicate = data.some(
            (item) => item.Name.trim().toLowerCase() === Name.trim().toLowerCase()
        );

        if (isDuplicate) {
            setErrorMessage("This Treatment Session Name already exists!");
            setIsLoading(false);
            return;
        }

        const TreatmentSession = {
            CompanyId: companyId,
            TreatmentId: selectedTreatment,
            Name,
            Rate,
            TaxRate,
            HSNcode,
            IsActive: true,
            CreatedBy: userId,
            CreatedDate: new Date(),
        };

        postData('TreatmentSessionApi', TreatmentSession, token)
            .then((response) => {
                console.log('Treatment Session Created success:', response);
                setSuccessMessage("Treatment Session Created successfully!");
                setErrorMessage("");
                setName("");
                setSelectedTreatment("");
                setSelectedTreatmentName("");
                setRate("");
                setTaxRate("");
                setHSNcode("");
                setSelectedTreatmentName('');

                setIsModalGrpOpen(false);
                window.location.reload();

                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Treatment Session Create error:', error);
                setErrorMessage('Failed to create Treatment Session');
            })
            .finally(() => {
                setIsLoading(false); // hide loader
            });
    };

    //EDIT
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const openDetailModal = async (Id) => {
        try {
            const response = await fetchData('TreatmentSessionApi', `/MasterDetails/${Id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                // Set the selected treatment when opening edit modal
                setSelectedTreatment(response.response_data.TreatmentId || '');
                setSelectedTreatmentName(response.response_data.TreatmentName || '');
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Treatment Session Details:', error);
        }
    };

    // master Group model
    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const toggleModalGroup = () => {
        setIsModalGrpOpen(!isModalGrpOpen);
        if (isModalGrpOpen) {
            // Reset when closing
            setSelectedTreatment('');
            setErrorMessage('');
        }
    };

    const toggleModalGrp2 = () => {
        setIsDetailModalOpen(false);
        setSelectedTreatment('');
        setErrorMessageEdit('');
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});

    const updateRecord = async (event) => {
        event.preventDefault();
        setIsUpdateLoading(true); // start loading

        if (!updatedData.Name) {
            setErrorMessageEdit('Name is required !');
            setIsUpdateLoading(false);
            return;
        }

        try {
            // Include TreatmentCatgeoryId from the selected dropdown
            const dataToUpdate = {
                ...updatedData,
                TreatmentId: selectedTreatment || updatedData.TreatmentId
            };
            await updateData('TreatmentSessionApi', `${updatedData.Id}`, dataToUpdate, token);
            setUpdateData({
                CompanyId: companyId,
                Name: '',
            });
            //setSelectedBalanceSheetType(null);
            window.location.reload();
            setIsDetailModalOpen(false);
            setSelectedTreatmentName('');
            fetchtableData();
        } catch (error) {
            console.error('Error updating record:', error);
        } finally {
            setIsUpdateLoading(false); // stop loading
        }
    };

    const [treatment, setTreatment] = useState([]);
    const [selectedTreatment, setSelectedTreatment] = useState("");
    const [selectedTreatmentName, setSelectedTreatmentName] = useState("");
    const [isTreatmentModalOpen, setIsTreatmentModalOpen] = useState(false);
    const [treatmentSearchQuery, setTreatmentSearchQuery] = useState('');

    const fetchTreatmentCategory = async () => {
        try {
            const response = await fetchData('TreatmentApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                setTreatment(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Treatment Session:', error);
        }
    };

    // Handle treatment selection from modal
    const handleTreatmentSelect = (selectedTreatmentData) => {
        setSelectedTreatment(selectedTreatmentData.Id);
        setSelectedTreatmentName(selectedTreatmentData.Name);

        // If in edit mode, update the updatedData state
        if (isDetailModalOpen) {
            setUpdateData(prev => ({
                ...prev,
                Rate: selectedTreatmentData.Rate || '',
                TaxRate: selectedTreatmentData.TaxRate || '',
                HSNcode: selectedTreatmentData.HSNcode || ''
            }));
        } else {
            // If in create mode, update the create form states
            setRate(selectedTreatmentData.Rate || '');
            setTaxRate(selectedTreatmentData.TaxRate || '');
            setHSNcode(selectedTreatmentData.HSNcode || '');
        }

        setIsTreatmentModalOpen(false);
        setTreatmentSearchQuery('');
    };


    return (
        <div className="container mt-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px',
                padding: '8px 12px',
                //background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                marginTop: '-15px'
            }}>
                <h6 style={{
                    margin: 0,
                    fontSize: '12px',
                    fontWeight: '700',
                    color: '#2d3748',
                    letterSpacing: '-0.3px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    textTransform: 'uppercase',
                }}>
                    Treatment Session
                </h6>

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ position: 'relative' }}>
                        <input
                            type="text"
                            placeholder="Search Treatment Session..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '280px' : '220px',
                                height: '32px',
                                border: '2px solid',
                                borderColor: isFocused ? '#667eea' : '#e2e8f0',
                                borderRadius: '12px',
                                padding: '0 16px 0 40px',
                                fontSize: '14px',
                                transition: 'all 0.3s ease',
                                outline: 'none',
                                background: 'white',
                                boxShadow: isFocused ? '0 4px 12px rgba(102, 126, 234, 0.15)' : 'none',
                            }}
                        />

                    </div>

                    <Tooltip title="Add New Treatment Session" arrow placement="top">
                        <Button
                            onClick={toggleModalGroup}
                            style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                fontWeight: '600',
                                height: '32px',
                                padding: '0 24px',
                                fontSize: '13px',
                                textTransform: 'none',
                                borderRadius: '12px',
                                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                                transition: 'all 0.3s ease',
                                border: 'none',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                            }}
                        >
                            + New Treatment Session
                        </Button>
                    </Tooltip>
                </div>
            </div>

            {isModalGrpOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                    <div
                        className="bg-white w-full overflow-hidden"
                        style={{
                            maxWidth: '900px',
                            maxHeight: '70vh',
                            borderRadius: '16px',
                            boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                            animation: 'zoomIn 0.3s ease-out'
                        }}
                    >
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            //background: 'linear-gradient(135deg, #041815ff 0%, #045157ff 100%)',
                            padding: '16px 24px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                            height: '55px',
                        }}>
                            <div style={{ height: '20px' }}>
                                <h6 style={{
                                    color: 'white',
                                    fontSize: '15px',
                                    fontWeight: '700',
                                    margin: 0,
                                    letterSpacing: '-0.3px',
                                    marginTop: '-10px'
                                }}>
                                    New Treatment Session
                                </h6>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    fontSize: '13px',
                                    margin: '2px 0 0 0'
                                }}>
                                    Add a new Treatment Session to your system
                                </p>
                            </div>
                            <button
                                onClick={toggleModalGroup}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.2)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '36px',
                                    height: '36px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    color: 'white',
                                    fontSize: '22px',
                                    fontWeight: '300'
                                }}
                                onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                                onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                            >
                                ×
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div className="overflow-y-auto" style={{ maxHeight: 'calc(85vh - 150px)', padding: '16px 20px' }}>

                            {errorMessage && (
                                <div style={{
                                    background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
                                    border: '1px solid #fca5a5',
                                    borderRadius: '12px',
                                    padding: '16px',
                                    marginBottom: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px'
                                }}>
                                    <span style={{ fontSize: '20px' }}>⚠️</span>
                                    <p style={{ color: '#991b1b', fontSize: '14px', margin: 0, fontWeight: '500' }}>{errorMessage}</p>
                                </div>
                            )}

                            <form onSubmit={addGroupRecord}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

                                    {/* Section 1: Basic Information */}
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">

                                        {/* Treatment - Clickable Field */}
                                        <div>
                                            <label
                                                style={{
                                                    display: 'block',
                                                    marginBottom: '6px',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    color: '#374151',
                                                }}
                                            >
                                                Treatment <span style={{ color: '#dc2626' }}>*</span>
                                            </label>

                                            <input
                                                type="text"
                                                readOnly
                                                placeholder="Click to select treatment"
                                                value={selectedTreatmentName}
                                                onClick={() => setIsTreatmentModalOpen(true)}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    outline: 'none',
                                                    backgroundColor: 'white',
                                                    height: '36px',
                                                    cursor: 'pointer'
                                                }}
                                            />
                                        </div>

                                        {/* Name Input */}
                                        <div className="md:col-span-2">
                                            <label
                                                style={{
                                                    display: 'block',
                                                    color: '#374151',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    marginBottom: '6px',
                                                }}
                                            >
                                                Name <span style={{ color: '#ef4444' }}>*</span>
                                            </label>

                                            <input
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                                placeholder="Enter Treatment name"
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    outline: 'none',
                                                    height: '36px',
                                                    transition: 'all 0.2s ease',
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#667eea';
                                                    e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.2)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e5e7eb';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Rate / TaxRate / HSN Section */}
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                        {[
                                            { label: 'Rate', value: Rate, setter: setRate, placeholder: 'Treatment Rate', alignRight: true },
                                            { label: 'TaxRate', value: TaxRate, setter: setTaxRate, placeholder: 'Tax Value', alignRight: true },
                                            { label: 'HSNcode', value: HSNcode, setter: setHSNcode, placeholder: 'HSN Code', alignRight: false },
                                        ].map((field, index) => (
                                            <div key={index}>
                                                <label
                                                    style={{
                                                        display: 'block',
                                                        color: '#374151',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '6px'
                                                    }}
                                                >
                                                    {field.label}
                                                </label>

                                                <input
                                                    type="text"
                                                    value={field.value}
                                                    onChange={(e) => field.setter(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '9px 12px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '10px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '32px',
                                                        textAlign: field.alignRight ? 'right' : 'left',   // 👈 RIGHT ALIGN FOR RATE & TAXRATE
                                                    }}
                                                    placeholder={field.placeholder}
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>

                                </div>
                            </form>

                        </div>

                        {/* Modal Footer */}
                        <div style={{
                            background: 'linear-gradient(to right, #f9fafb, #f3f4f6)',
                            padding: '16px 24px',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '12px',
                            borderTop: '1px solid #e5e7eb'
                        }}>
                            <button
                                onClick={toggleModalGroup}
                                disabled={isLoading}
                                style={{
                                    padding: '8px 24px',
                                    background: 'white',
                                    border: '2px solid #e5e7eb',
                                    borderRadius: '10px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: '#6b7280',
                                    cursor: isLoading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    opacity: isLoading ? 0.5 : 1
                                }}
                                onMouseEnter={(e) => !isLoading && (e.target.style.background = '#f9fafb')}
                                onMouseLeave={(e) => !isLoading && (e.target.style.background = 'white')}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={addGroupRecord}
                                disabled={isLoading}
                                style={{
                                    padding: '8px 24px',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    //background: 'linear-gradient(135deg, #041815ff 0%, #045157ff 100%)',
                                    border: 'none',
                                    borderRadius: '10px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: 'white',
                                    cursor: isLoading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                                    opacity: isLoading ? 0.7 : 1
                                }}
                                onMouseEnter={(e) => !isLoading && (e.target.style.transform = 'translateY(-2px)')}
                                onMouseLeave={(e) => !isLoading && (e.target.style.transform = 'translateY(0)')}
                            >
                                {isLoading ? (
                                    <>
                                        <CircularProgress size={18} color="inherit" />
                                        <span>Saving...</span>
                                    </>
                                ) : (
                                    <>
                                        <span>✓</span>
                                        <span>Add Treatment</span>
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )
            }

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', width: '100%', marginTop: '-15px' }}>
                <TableContainer component={Paper} sx={{
                    borderRadius: '8px',
                    overflow: 'hidden',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08)',
                    border: '1px solid #e5e7eb'
                }}>
                    <Table stickyHeader>

                        <TableHead>
                            <TableRow>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)",
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '11.5px',
                                        borderRight: '1px solid rgba(255,255,255,0.1)',
                                        borderBottom: '2px solid #1e40af',
                                        textAlign: 'center',
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        whiteSpace: 'nowrap',
                                        padding: '2px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                    }}>
                                    Sl.No
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)",
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '11.5px',
                                        borderRight: '1px solid rgba(255,255,255,0.1)',
                                        borderBottom: '2px solid #1e40af',
                                        textAlign: 'left',
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        whiteSpace: 'nowrap',
                                        padding: '2px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                    }}>
                                    HSN Code
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)",
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '11.5px',
                                        borderRight: '1px solid rgba(255,255,255,0.1)',
                                        borderBottom: '2px solid #1e40af',
                                        textAlign: 'left',
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        whiteSpace: 'nowrap',
                                        padding: '2px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                    }}>
                                    Treatment
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)",
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '11.5px',
                                        borderRight: '1px solid rgba(255,255,255,0.1)',
                                        borderBottom: '2px solid #1e40af',
                                        textAlign: 'left',
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        whiteSpace: 'nowrap',
                                        padding: '2px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                    }}>
                                    Session
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)",
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '11.5px',
                                        borderRight: '1px solid rgba(255,255,255,0.1)',
                                        borderBottom: '2px solid #1e40af',
                                        textAlign: 'left',
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        whiteSpace: 'nowrap',
                                        padding: '2px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                    }}>
                                    Rate
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)",
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '11.5px',
                                        borderRight: '1px solid rgba(255,255,255,0.1)',
                                        borderBottom: '2px solid #1e40af',
                                        textAlign: 'left',
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        whiteSpace: 'nowrap',
                                        padding: '2px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                    }}>
                                    Tax
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)",
                                        color: 'white',
                                        fontWeight: '700',
                                        fontSize: '11.5px',
                                        borderBottom: '2px solid #1e40af',
                                        textAlign: 'center',
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        whiteSpace: 'nowrap',
                                        padding: '2px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                    }}>
                                    Actions
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: '#f0f9ff',
                                        },
                                        transition: 'background-color 0.15s ease',
                                        cursor: 'pointer',
                                        '&:nth-of-type(even)': {
                                            backgroundColor: '#fafafa',
                                        }
                                    }}
                                >
                                    <TableCell sx={{
                                        padding: '6px 4px',
                                        fontSize: '11.5px',
                                        fontWeight: '600',
                                        color: '#1e40af',
                                        textAlign: 'center',
                                        width: '5%',
                                        borderRight: '1px solid #e5e7eb',
                                        borderBottom: '1px solid #e5e7eb'
                                    }}>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 12px',
                                        textAlign: 'left',
                                        fontSize: '11.5px',
                                        color: '#1f2937',
                                        fontWeight: '500',
                                        width: '10%',
                                        borderRight: '1px solid #e5e7eb',
                                        borderBottom: '1px solid #e5e7eb'
                                    }}>
                                        {item.HSNcode}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 12px',
                                        textAlign: 'left',
                                        fontSize: '11.5px',
                                        color: '#1f2937',
                                        fontWeight: '500',
                                        width: '30%',
                                        borderRight: '1px solid #e5e7eb',
                                        borderBottom: '1px solid #e5e7eb'
                                    }}>
                                        {item.TreatmentName}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 12px',
                                        textAlign: 'left',
                                        fontSize: '11.5px',
                                        color: '#1f2937',
                                        fontWeight: '500',
                                        width: '30%',
                                        borderRight: '1px solid #e5e7eb',
                                        borderBottom: '1px solid #e5e7eb'
                                    }}>
                                        {item.Name}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 12px',
                                        textAlign: 'left',
                                        fontSize: '11.5px',
                                        color: '#1f2937',
                                        fontWeight: '500',
                                        width: '10%',
                                        borderRight: '1px solid #e5e7eb',
                                        borderBottom: '1px solid #e5e7eb'
                                    }}>
                                        {item.Rate}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 12px',
                                        textAlign: 'left',
                                        fontSize: '11.5px',
                                        color: '#1f2937',
                                        fontWeight: '500',
                                        width: '10%',
                                        borderRight: '1px solid #e5e7eb',
                                        borderBottom: '1px solid #e5e7eb'
                                    }}>
                                        {item.TaxRate}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: '6px 4px',
                                        textAlign: 'center',
                                        width: '10%',
                                        borderBottom: '1px solid #e5e7eb'
                                    }}>
                                        {/* {hasEditMasterPermission && ( */}
                                        <Tooltip title="Edit" arrow placement="top">
                                            <IconButton
                                                onClick={() => openDetailModal(item.Id)}
                                                sx={{
                                                    padding: '4px',
                                                    marginRight: '4px',
                                                    '&:hover': {
                                                        backgroundColor: '#dbeafe',
                                                    },
                                                }}
                                            >
                                                <EditIcon style={{ color: '#1e40af', fontSize: '16px' }} />
                                            </IconButton>
                                        </Tooltip>
                                        {/* )}
                                        {hasDeleteMasterPermission && ( */}
                                        <Tooltip title="Delete" arrow placement="top">
                                            <IconButton
                                                onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}
                                                sx={{
                                                    padding: '4px',
                                                    '&:hover': {
                                                        backgroundColor: '#fee2e2',
                                                    },
                                                }}
                                            >
                                                {item.IsActive ? <DeleteIcon style={{ color: '#dc2626', fontSize: '16px' }} /> : <ActivateIcon style={{ color: '#059669', fontSize: '16px' }} />}
                                            </IconButton>
                                        </Tooltip>
                                        {/* )} */}
                                    </TableCell>
                                </TableRow>
                            ))}

                        </TableBody>

                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                                    Cancel
                                </button>
                                <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>

                    </Table>
                </TableContainer>

                {isDetailModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                        <div
                            className="bg-white w-full overflow-hidden"
                            style={{
                                maxWidth: '900px',
                                maxHeight: '70vh',
                                borderRadius: '16px',
                                boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                                animation: 'zoomIn 0.3s ease-out'
                            }}
                        >
                            {/* Modal Header */}
                            <div style={{
                                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                padding: '16px 24px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                                height: '55px',
                            }}>
                                <div style={{ height: '20px' }}>
                                    <h6 style={{
                                        color: 'white',
                                        fontSize: '15px',
                                        fontWeight: '700',
                                        margin: 0,
                                        letterSpacing: '-0.3px',
                                        marginTop: '-10px'
                                    }}>
                                        Edit Treatment
                                    </h6>
                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        fontSize: '13px',
                                        margin: '2px 0 0 0'
                                    }}>
                                        Update Treatment information
                                    </p>
                                </div>
                                <button
                                    onClick={toggleModalGrp2}
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.2)',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '36px',
                                        height: '36px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        color: 'white',
                                        fontSize: '22px',
                                        fontWeight: '300'
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                                    onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                                >
                                    ×
                                </button>
                            </div>

                            {/* Modal Body */}
                            <div className="overflow-y-auto" style={{ maxHeight: 'calc(75vh - 150px)', padding: '16px 20px' }}>
                                {errorMessageEdit && (
                                    <div style={{
                                        background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
                                        border: '1px solid #fca5a5',
                                        borderRadius: '12px',
                                        padding: '16px',
                                        marginBottom: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px'
                                    }}>
                                        <span style={{ fontSize: '20px' }}>⚠️</span>
                                        <p style={{ color: '#991b1b', fontSize: '14px', margin: 0, fontWeight: '500' }}>{errorMessageEdit}</p>
                                    </div>
                                )}

                                <form onSubmit={updateRecord}>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                            <div>
                                                <label
                                                    style={{
                                                        display: 'block',
                                                        marginBottom: '6px',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        color: '#374151',
                                                    }}
                                                >
                                                    Treatment <span style={{ color: '#dc2626' }}>*</span>
                                                </label>

                                                <input
                                                    type="text"
                                                    readOnly
                                                    placeholder="Click to select treatment"
                                                    value={selectedTreatmentName}
                                                    onClick={() => setIsTreatmentModalOpen(true)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '8px 12px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        fontSize: '13px',
                                                        outline: 'none',
                                                        backgroundColor: 'white',
                                                        height: '36px',
                                                        cursor: 'pointer'
                                                    }}
                                                />
                                            </div>

                                            <div className="md:col-span-2">
                                                <label
                                                    style={{
                                                        display: 'block',
                                                        color: '#374151',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '6px',
                                                    }}
                                                >
                                                    Name <span style={{ color: '#ef4444' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="Name"
                                                    value={updatedData.Name || ''}
                                                    onChange={handleUpdateInputChange}
                                                    style={{
                                                        width: '100%',
                                                        padding: '7px 10px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '32px'
                                                    }}
                                                    placeholder="Enter Treatment Session name"
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Rate / TaxRate / HSN Section */}
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                            <div className="md:col-span-1">
                                                <label
                                                    style={{
                                                        display: 'block',
                                                        color: '#374151',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '6px',
                                                    }}
                                                >
                                                    Rate <span style={{ color: '#ef4444' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="Rate"
                                                    value={updatedData.Rate || ''}
                                                    onChange={handleUpdateInputChange}
                                                    style={{
                                                        width: '100%',
                                                        padding: '7px 10px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '32px',
                                                        textAlign: 'right'
                                                    }}
                                                    placeholder="Enter Rate"
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>
                                            <div className="md:col-span-1">
                                                <label
                                                    style={{
                                                        display: 'block',
                                                        color: '#374151',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '6px',
                                                    }}
                                                >
                                                    Tax Rate <span style={{ color: '#ef4444' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="TaxRate"
                                                    value={updatedData.TaxRate || ''}
                                                    onChange={handleUpdateInputChange}
                                                    style={{
                                                        width: '100%',
                                                        padding: '7px 10px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '32px',
                                                        textAlign: 'right'
                                                    }}
                                                    placeholder="Enter TaxRate"
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>
                                            <div className="md:col-span-1">
                                                <label
                                                    style={{
                                                        display: 'block',
                                                        color: '#374151',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '6px',
                                                    }}
                                                >
                                                    HSN Code <span style={{ color: '#ef4444' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="HSNcode"
                                                    value={updatedData.HSNcode || ''}
                                                    onChange={handleUpdateInputChange}
                                                    style={{
                                                        width: '100%',
                                                        padding: '7px 10px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '32px'
                                                    }}
                                                    placeholder="Enter HSNcode"
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            {/* Modal Footer */}
                            <div style={{
                                background: 'linear-gradient(to right, #f9fafb, #f3f4f6)',
                                padding: '16px 24px',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '12px',
                                borderTop: '1px solid #e5e7eb'
                            }}>
                                <button
                                    onClick={toggleModalGrp2}
                                    disabled={isUpdateLoading}
                                    style={{
                                        padding: '8px 24px',
                                        background: 'white',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '10px',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: '#6b7280',
                                        cursor: isUpdateLoading ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s ease',
                                        opacity: isUpdateLoading ? 0.5 : 1
                                    }}
                                    onMouseEnter={(e) => !isUpdateLoading && (e.target.style.background = '#f9fafb')}
                                    onMouseLeave={(e) => !isUpdateLoading && (e.target.style.background = 'white')}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={updateRecord}
                                    disabled={isUpdateLoading}
                                    style={{
                                        padding: '8px 24px',
                                        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                        border: 'none',
                                        borderRadius: '10px',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: 'white',
                                        cursor: isUpdateLoading ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)',
                                        opacity: isUpdateLoading ? 0.7 : 1
                                    }}
                                    onMouseEnter={(e) => !isUpdateLoading && (e.target.style.transform = 'translateY(-2px)')}
                                    onMouseLeave={(e) => !isUpdateLoading && (e.target.style.transform = 'translateY(0)')}
                                >
                                    {isUpdateLoading ? (
                                        <>
                                            <CircularProgress size={18} color="inherit" />
                                            <span>Updating...</span>
                                        </>
                                    ) : (
                                        <>
                                            <span>✓</span>
                                            <span>Update Treatment</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                )
                }

                {/* Treatment Selection Modal */}
                {isTreatmentModalOpen && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        backdropFilter: 'blur(4px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        padding: '20px'
                    }}>
                        <div style={{
                            background: 'white',
                            borderRadius: '12px',
                            width: '100%',
                            maxWidth: '900px',
                            maxHeight: '80vh',
                            overflow: 'hidden',
                            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)'
                        }}>
                            {/* Modal Header */}
                            <div style={{
                                background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
                                padding: '16px 20px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                borderBottom: '2px solid #1e40af',
                                height: '40px'
                            }}>
                                <div>
                                    <p style={{
                                        color: 'rgba(255,255,255,0.9)',
                                        fontSize: '13px',
                                        margin: '4px 0 0 0'
                                    }}>
                                        Search and select a treatment
                                    </p>
                                </div>
                                <button
                                    onClick={() => {
                                        setIsTreatmentModalOpen(false);
                                        setTreatmentSearchQuery('');
                                    }}
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.2)',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '30px',
                                        height: '30px',
                                        cursor: 'pointer',
                                        color: 'white',
                                        fontSize: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                                    onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                                >
                                    ×
                                </button>
                            </div>

                            {/* Search Bar */}
                            <div style={{ padding: '6px 12px', borderBottom: '1px solid #e5e7eb' }}>
                                <input
                                    type="text"
                                    placeholder="Search by Treatment Name, Category..."
                                    value={treatmentSearchQuery}
                                    onChange={(e) => setTreatmentSearchQuery(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '10px 16px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '13px',
                                        outline: 'none',
                                        transition: 'all 0.2s ease',
                                        height: '27px'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#1e40af'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                />
                            </div>

                            {/* Treatment Table */}
                            <div style={{
                                maxHeight: 'calc(80vh - 200px)',
                                overflowY: 'auto',
                                padding: '0',
                                marginLeft: '10px',
                                marginRight: '10px'
                            }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                        <tr>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
                                                color: 'white',
                                                padding: '4px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Treatment Category
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
                                                color: 'white',
                                                padding: '4px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Treatment Name
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
                                                color: 'white',
                                                padding: '4px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'right',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Rate
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
                                                color: 'white',
                                                padding: '4px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'right',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Tax Rate
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
                                                color: 'white',
                                                padding: '4px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px'
                                            }}>
                                                HSN Code
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {treatment
                                            .filter(item =>
                                                item.Name?.toLowerCase().includes(treatmentSearchQuery.toLowerCase()) ||
                                                item.TreatmentCatgeoryName?.toLowerCase().includes(treatmentSearchQuery.toLowerCase()) ||
                                                item.HSNcode?.toLowerCase().includes(treatmentSearchQuery.toLowerCase())
                                            )
                                            .map((item, index) => (
                                                <tr
                                                    key={item.Id}
                                                    onClick={() => handleTreatmentSelect(item)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.15s ease',
                                                        backgroundColor: index % 2 === 0 ? 'white' : '#fafafa'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f9ff'}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? 'white' : '#fafafa'}
                                                >
                                                    <td style={{
                                                        padding: '10px',
                                                        fontSize: '12px',
                                                        color: '#1f2937',
                                                        fontWeight: '500',
                                                        borderBottom: '1px solid #e5e7eb',
                                                        borderRight: '1px solid #e5e7eb'
                                                    }}>
                                                        {item.TreatmentCatgeoryName || 'N/A'}
                                                    </td>
                                                    <td style={{
                                                        padding: '10px',
                                                        fontSize: '12px',
                                                        color: '#1e40af',
                                                        fontWeight: '600',
                                                        borderBottom: '1px solid #e5e7eb',
                                                        borderRight: '1px solid #e5e7eb'
                                                    }}>
                                                        {item.Name}
                                                    </td>
                                                    <td style={{
                                                        padding: '10px',
                                                        fontSize: '12px',
                                                        color: '#1f2937',
                                                        fontWeight: '500',
                                                        textAlign: 'right',
                                                        borderBottom: '1px solid #e5e7eb',
                                                        borderRight: '1px solid #e5e7eb'
                                                    }}>
                                                        {item.Rate || '0'}
                                                    </td>
                                                    <td style={{
                                                        padding: '10px',
                                                        fontSize: '12px',
                                                        color: '#1f2937',
                                                        fontWeight: '500',
                                                        textAlign: 'right',
                                                        borderBottom: '1px solid #e5e7eb',
                                                        borderRight: '1px solid #e5e7eb'
                                                    }}>
                                                        {item.TaxRate || '0'}%
                                                    </td>
                                                    <td style={{
                                                        padding: '10px',
                                                        fontSize: '12px',
                                                        color: '#1f2937',
                                                        fontWeight: '500',
                                                        borderBottom: '1px solid #e5e7eb'
                                                    }}>
                                                        {item.HSNcode || 'N/A'}
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {treatment.filter(item =>
                                    item.Name?.toLowerCase().includes(treatmentSearchQuery.toLowerCase()) ||
                                    item.TreatmentCatgeoryName?.toLowerCase().includes(treatmentSearchQuery.toLowerCase()) ||
                                    item.HSNcode?.toLowerCase().includes(treatmentSearchQuery.toLowerCase())
                                ).length === 0 && (
                                        <div style={{
                                            padding: '40px',
                                            textAlign: 'center',
                                            color: '#6b7280',
                                            fontSize: '13px'
                                        }}>
                                            No treatments found
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                )}

                <div style={{
                    position: 'fixed',
                    bottom: '12px',
                    right: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.3rem',
                    padding: '0.3rem 0.65rem',
                    background: 'rgba(255, 255, 255, 0.9)',
                    borderRadius: '14px',
                    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.06)',
                    fontFamily: 'serif',
                    fontWeight: 'bold',
                    color: '#2c3e50',
                    fontSize: '0.7rem',
                    backdropFilter: 'blur(10px)'
                }}>
                    <CopyrightIcon />
                    <b>EFFTABS SOLUTIONS LLP</b>
                </div>
            </div >
        </div >
    );
}

export default TSessionIndex;
